import React from 'react';
import PropTypes from 'prop-types';

import { MenuItemDescriptionContainer } from 'components/FlyoutMenu/styles';
import {
  LabelContainer,
  LabelTag,
} from 'components/FlyoutMenu/components/MenuItem/styles';
import Text from '../../../../shared/Text/index.tsx';
import Box from '../../../../shared/Box';
import { IconBadge } from '../../../IconBadge';

const MenuItem = ({ label, labelTag, description, icon }) => (
  <Box
    key={label}
    height={description ? 80 : 48}
    paddingLeft={14}
    paddingRight={14}
    display="flex"
    alignItems="center"
  >
    {icon && (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        marginRight={14}
      >
        <IconBadge
          type={icon.type}
          iconColor={icon.iconColor}
          backgroundColor={icon.backgroundColor}
          width={icon.width}
          padding={icon.padding}
        />
      </Box>
    )}
    <div>
      <LabelContainer>
        <Text color="#292f36" isBold size="xl" isInline>
          {label}
        </Text>
        {labelTag && <LabelTag>{labelTag}</LabelTag>}
      </LabelContainer>
      {description && (
        <MenuItemDescriptionContainer>
          <Text color="#5f6368" size="m">
            {description}
          </Text>
        </MenuItemDescriptionContainer>
      )}
    </div>
  </Box>
);

MenuItem.defaultProps = { icon: null };
MenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  labelTag: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.shape({
    backgroundColor: PropTypes.string,
    iconColor: PropTypes.string,
    padding: PropTypes.number,
    type: PropTypes.string,
    width: PropTypes.number,
  }),
};

export { MenuItem };
